import { TableCell, Typography } from '@mui/material';
import { FC } from 'react';

type Props = Readonly<{
	content?: string;
	children?: any;
	isActionButton?: boolean;
	cellWidth?: number;
}>;
export const CustomTableCell: FC<Props> = ({ content, children, cellWidth, isActionButton = false }) => {
	const actiobButtonCellStyle = isActionButton && { textAlign: 'right', width: 4.5 };
	return (
		<TableCell
			width={cellWidth}
			scope={'row'}
			sx={{ borderBottom: (theme) => `1px solid  ${theme.palette.divider}`, ...actiobButtonCellStyle }}
		>
			{content != null && <Typography variant={'button'}>{content}</Typography>}
			{children != null && <Typography variant={'button'}>{children}</Typography>}
		</TableCell>
	);
};
